var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content",style:({height: '100%', padding: _vm.isMain ? '20px' : 0 })},[_c('iframe',{style:({'transform': 'scale(' + _vm.scale + ')', 'transform-origin': 'left top'}),attrs:{"src":_vm.src,"frameborder":"0","width":"100%","height":"100%","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }